// import React, { useState, useEffect } from "react";
// import Main from "../pages/Main";
// import { useWallet } from "../context/walletContext";
// import { fetch_bill_operators, fetch_billPay_info, submit_billPay_amount } from "../api/billPayApi";
// import ServicesForm from "./ServicesForm";
// import { getLocation } from "../components/Navigator/Navigator";
// import { useDispatch, useSelector } from "react-redux";
// import { formatAmount } from "../utils/formatAmount";
// import { useNotify } from "../context/NotifyContext";
// import { setLocation } from "../features/authSlice";
// import { Autocomplete, TextField } from "@mui/material";
// import { AppBreadcrumbs } from "../components/listing";

// const NewPayment = () => {
//   const { notify } = useNotify();
//   const { walletAmt } = useWallet();
//   const { userInfo, location: savedLocation } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();

//   const [operators, setOperators] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedOperatorId, setSelectedOperatorId] = useState("");
//   const [selectedOperator, setSelectedOperator] = useState(null);

//   const [canumber, setCanumber] = useState("");
//   const [adFields, setAdFields] = useState({ ad1: "", ad2: "", ad3: "", ad4: "" });
//   const [paymentType, setPaymentType] = useState("");

//   const [billDetails, setBillDetails] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // ================= LOAD OPERATORS =================
//   useEffect(() => {
//     const load = async () => {
//       const res = await fetch_bill_operators();
//       if (res?.success) {
//         setOperators(res.data?.operators || []);
//         setCategories(res.data?.categories || []);
//       }
//     };
//     load();
//   }, []);

//   // ================= SELECT OPERATOR =================
//   useEffect(() => {
//     const op = operators.find((o) => String(o.operatorId) === String(selectedOperatorId));
//     setSelectedOperator(op || null);

//     console.log("selcted op",op)
//     // Reset fields when operator changes
//     setCanumber("");
//     setAdFields({ ad1: "", ad2: "", ad3: "", ad4: "" });
//     setPaymentType("");
//     setBillDetails(null);
//     setShowForm(false);
//   }, [selectedOperatorId]);

//   // ================= VALIDATION =================
//   const validateInput = () => {
//     if (!selectedOperator) return notify("Select operator", "error");

//     if (!canumber.trim()) {
//       notify(`Enter ${selectedOperator.displayname || "Consumer Number"}`, "error");
//       return false;
//     }

//     // Consumer regex
//     if (selectedOperator.regex) {
//       try {
//         const reg = new RegExp(selectedOperator.regex);
//         if (!reg.test(canumber)) return notify("Invalid Consumer Number Format", "error");
//       } catch {}
//     }

//  ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
//   if (selectedOperator?.[`${k}_name`] && !adFields[k]) {
//     notify(`Enter ${selectedOperator[`${k}_d_name`]}`, "error");
//     throw new Error("Validation stop");
//   }
// });

  

//     // Hero FinCorp payment type
//     if (String(selectedOperatorId) === "157" && !paymentType)
//       return notify("Select Payment Type", "error");

//     return true;
//   };

//   // ================= LPG LOGIC =================
// const handleCanumberChange = (e) => {
//   const value = e.target.value;
//   setCanumber(value);

//   // LPG Rule Paysprint
//   if (selectedOperator?.category === "LPG") {
//     if (value.length > 10) {
//       setAdFields((p) => ({ ...p, ad1: "1" })); // LPG ID
//     } else {
//       setAdFields((p) => ({ ...p, ad1: "2" })); // Mobile
//     }
//   }
// };


//   // ================= FETCH BILL =================
// //   const handleProcess = async () => {
// //     try {
// //       if (!validateInput()) return;
// //     } catch {
// //       return;
// //     }


// //     setLoading(true);
// //     try {
   
// //       const adPayload = {};
// // ["ad1","ad2","ad3","ad4"].forEach((k) => {
// //   if (selectedOperator?.[`${k}_name`] && adFields[k])
// //     adPayload[selectedOperator[`${k}_name`]] = adFields[k];
// // });

// // const payload = { operatorId: selectedOperatorId, canumber, ...adPayload, paymentType };




// //       const res = await fetch_billPay_info(payload);
// //       if (res?.success) {
// //         notify("Bill fetched successfully", "success");
// //         console.log("get the data",res?.data)
// //         setBillDetails(res.data?.bill);
// //         setShowForm(true);
// //       } else {
// //         notify(res?.message || "Bill fetch failed", "error");
// //       }
// //     } catch {
// //       notify("Server Error", "error");
// //     }
// //     setLoading(false);
// //   };

// const handleProcess = async () => {
//   try {
//     if (!validateInput()) return;
//   } catch {
//     return;
//   }

//   setLoading(true);
//   try {
//     // ✅ Build ad payload (IMPORTANT)
//     const adPayload = {};
//     ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
//       if (selectedOperator?.[`${k}_name`] && adFields[k]) {
//         adPayload[k] = String(adFields[k]).trim(); // MUST be ad1/ad2 keys
//       }
//     });

//     // ✅ Final Payload
//     const payload = {
//       operatorId: selectedOperatorId,
//       canumber: String(canumber).trim(),
//       mode: "online",
//       ...adPayload,
//       paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
//     };

//     console.log("🔥 FRONTEND BILL FETCH PAYLOAD:", payload);

//     const res = await fetch_billPay_info(payload);

//     if (res?.success) {
//       notify("Bill fetched successfully", "success");
//       console.log("✅ BILL RESPONSE:", res.data?.bill);
//       setBillDetails(res.data?.bill);
//       setShowForm(true);
//     } else {
//       notify(res?.message || "Bill fetch failed", "error");
//     }
//   } catch (err) {
//     console.error("❌ Frontend Fetch Error:", err);
//     notify("Server Error", "error");
//   }

//   setLoading(false);
// };


//   // ================= PAY BILL =================
// const handleSubmitFromChild = async (data) => {
//   if (!data?.amount) return notify("Enter amount", "error");

//   setLoading(true);
//   try {
//     let location = savedLocation;
//     if (!location) {
//       location = await getLocation();
//       dispatch(setLocation(location));
//     }

//     // Build ad payload again
//     const adPayload = {};
//     ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
//       if (selectedOperator?.[`${k}_name`] && adFields[k]) {
//         adPayload[k] = String(adFields[k]).trim();
//       }
//     });

//     const payload = {
//       amount: data.amount,
//       bill_fetch: billDetails?.bill_fetch,
//       canumber: String(canumber),
//       operator: selectedOperator.operatorId,
//       category: selectedOperator.category,
//       latitude: location.latitude,
//       longitude: location.longitude,
//       paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
//       ...adPayload,
//     };

//     console.log("🔥 FRONTEND PAYMENT PAYLOAD:", payload);

//     const res = await submit_billPay_amount(payload);

//     if (res?.success) {
//       notify("Payment Successful", "success");
//       ClearForm();
//     } else {
//       notify(res?.message || "Payment Failed", "error");
//     }
//   } catch (err) {
//     console.error("❌ Payment Error:", err);
//     notify("Server Error", "error");
//   }

//   setLoading(false);
// };


//   // ================= CLEAR =================
//   const ClearForm = () => {
//     setSelectedOperatorId("");
//     setSelectedOperator(null);
//     setCanumber("");
//     setAdFields({ ad1: "", ad2: "", ad3: "", ad4: "" });
//     setPaymentType("");
//     setBillDetails(null);
//     setShowForm(false);
//   };

//   // ================= UNIQUE OPERATORS =================
//   const uniqueOperators = operators.filter(
//     (op, i, self) =>
//       i === self.findIndex((o) => o.name === op.name && o.category === op.category)
//   );

//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "BBPS Bill Payment" },
//             { label: "New Transaction" },
//           ]}
//         />

//         <div className="ds-card mb-4 flex justify-between items-center gap-3">
//           <div className="flex items-center gap-3 min-w-0">
//             <img
//               src={`${userInfo?.logo}`}
//               alt=""
//               className="h-10 w-10 rounded-ds object-cover shrink-0"
//             />
//             <div className="min-w-0">
//               <p className="font-semibold text-[var(--text-dark)] truncate">{userInfo?.name}</p>
//               <p className="text-[13px] text-[var(--text-muted)]">ID: {userInfo?.userName}</p>
//             </div>
//           </div>
//           <p className="font-bold text-[var(--success-color)] whitespace-nowrap">
//             ₹ {formatAmount(walletAmt?.main?.balance)}
//           </p>
//         </div>

//         <div className="flex flex-col lg:flex-row gap-4">
//           <div className="ds-card w-full lg:max-w-[300px]">
//             <label className="ds-label">Select Operator *</label>
//             <Autocomplete
//               options={uniqueOperators}
//               getOptionLabel={(op) => op?.name || ""}
//               value={
//                 uniqueOperators.find(
//                   (o) => String(o.operatorId) === String(selectedOperatorId)
//                 ) || null
//               }
//               onChange={(e, v) => {
//                 setSelectedOperatorId(v?.operatorId || "");
//                 setSelectedOperator(v || null);
//               }}
//               filterOptions={(options, { inputValue }) => {
//                 const val = inputValue.toLowerCase();
//                 return options.filter(
//                   (o) =>
//                     o.name?.toLowerCase().includes(val) ||
//                     o.category?.toLowerCase().includes(val)
//                 );
//               }}
//               renderOption={(props, option) => (
//                 <li
//                   {...props}
//                   key={option.operatorId}
//                   className="flex justify-between items-start gap-2 p-1 overflow-x-hidden"
//                 >
//                   <span className="text-sm font-medium">{option.name}</span>
//                   <span className="text-xs text-[var(--warning-color)]">{option.category}</span>
//                 </li>
//               )}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   size="small"
//                   placeholder="Search Operator..."
//                   InputProps={{
//                     ...params.InputProps,
//                     style: {
//                       fontSize: "0.9rem",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                     },
//                   }}
//                 />
//               )}
//               fullWidth
//             />

//             <label className="ds-label mt-3">
//               {selectedOperator?.displayname || "Consumer Number"} *
//             </label>
//             <TextField fullWidth size="small" value={canumber} onChange={handleCanumberChange} />

//             {String(selectedOperatorId) === "157" && (
//               <>
//                 <label className="ds-label mt-2">Payment Type</label>
//                 <Autocomplete
//                   options={["Installment Amount Due", "Full Overdue", "Advance EMI", "Foreclosure"]}
//                   value={paymentType}
//                   onChange={(e, v) => setPaymentType(v)}
//                   renderInput={(p) => <TextField {...p} size="small" />}
//                 />
//               </>
//             )}

//             {["ad1", "ad2", "ad3", "ad4"].map((k) =>
//               selectedOperator?.[`${k}_name`] ? (
//                 <div key={k}>
//                   <label className="ds-label mt-2">{selectedOperator[`${k}_d_name`]}</label>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     value={adFields[k]}
//                     onChange={(e) => setAdFields({ ...adFields, [k]: e.target.value })}
//                   />
//                 </div>
//               ) : null
//             )}

//             <div className="ds-form-actions">
//               <button
//                 type="button"
//                 onClick={handleProcess}
//                 disabled={loading}
//                 className="ds-btn ds-btn-primary"
//               >
//                 {loading ? "Processing..." : "Process"}
//               </button>
//               <button type="button" onClick={ClearForm} className="ds-btn ds-btn-secondary">
//                 Clear
//               </button>
//             </div>
//           </div>

//           {!showForm && (
//             <div className="ds-card flex-1">
//               <h3 className="text-[15px] font-semibold mb-3 text-[var(--text-dark)]">
//                 Supported Categories
//               </h3>
//               <div className="grid grid-cols-2 md:grid-cols-4 text-[13px] gap-2 text-[var(--text-muted)]">
//                 {categories.map((c, i) => (
//                   <p key={i} className="flex items-center gap-1.5">
//                     <span className="text-[var(--success-color)]">✓</span> {c}
//                   </p>
//                 ))}
//               </div>
//             </div>
//           )}

//           {showForm && (
//             <ServicesForm
//               bill={billDetails}
//               close={ClearForm}
//               onSubmit={handleSubmitFromChild}
//               loading={loading}
//             />
//           )}
//         </div>
//       </div>
//     </Main>
//   );
// };

// export default NewPayment;

   
    //  done  wala
   

import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Main from "../pages/Main";
import { fetchActiveProviders } from "../api/providerApi";
import { useWallet } from "../context/walletContext";
import { fetch_bill_operators, fetch_billPay_info, submit_billPay_amount } from "../api/billPayApi";
import { fetch_cc_bill, pay_cc_bill, fetch_active_cc_billers } from "../api/creditCardBillApi";
import ServicesForm from "./ServicesForm";
import { getLocation } from "../components/Navigator/Navigator";
import { useDispatch, useSelector } from "react-redux";
import { formatAmount } from "../utils/formatAmount";
import { useNotify } from "../context/NotifyContext";
import { setLocation } from "../features/authSlice";
import { Autocomplete, TextField } from "@mui/material";
import { AppBreadcrumbs } from "../components/listing";

const EMPTY_AD = { ad1: "", ad2: "", ad3: "", ad4: "" };


const toMoney = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : "";
};

// OrderId: yyMMddHHmmss + 5 random digits + card last4 (e.g. 26071305510984918776733) 
  

const generateOrderId = (last4) => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const stamp = `${String(d.getFullYear()).slice(-2)}${p(d.getMonth() + 1)}${p(d.getDate())}${p(
    d.getHours()
  )}${p(d.getMinutes())}${p(d.getSeconds())}`;
  const rand = String(Math.floor(Math.random() * 100000)).padStart(5, "0");
  return `${stamp}${rand}${last4}`;
};

const isCreditCardOperator = (op) => /credit\s*card/i.test(op?.category || "");

const NewPayment = () => {
  const { notify } = useNotify();
  const navigate = useNavigate();
  const { providerCode } = useParams();
  const selectedProvider = String(providerCode || "").toUpperCase();
  const [ccProviderActive, setCcProviderActive] = useState(true);
  const { walletAmt } = useWallet();
  const { userInfo, location: savedLocation } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [operators, setOperators] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOperatorId, setSelectedOperatorId] = useState("");
  const [selectedOperator, setSelectedOperator] = useState(null);

  // normal bill fields
  const [canumber, setCanumber] = useState("");
  const [adFields, setAdFields] = useState(EMPTY_AD);
  const [paymentType, setPaymentType] = useState("");

  // credit card fields
  const [cardLast4, setCardLast4] = useState("");
  const [custMobile, setCustMobile] = useState("");
  const [param1, setParam1] = useState("");
  const [param2, setParam2] = useState("");

  const [billDetails, setBillDetails] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  // Same bill ke retries me same OrderId use hota hai (duplicate payment se bachne ke liye)
  const orderIdRef = useRef(null);

  useEffect(() => {
    if (!selectedProvider) {
      setCcProviderActive(true);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      const res = await fetchActiveProviders("CCBILL");
      if (cancelled) return;
      const list = res.data?.providers || [];
      const active = list.some(
        (row) => String(row.providerCode || "").toUpperCase() === selectedProvider
      );
      setCcProviderActive(active);
      if (!active) {
        notify("This credit card bill provider is inactive.", "error");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [notify, selectedProvider]);

  const isCreditCard = isCreditCardOperator(selectedOperator);

  useEffect(() => {
    if (isCreditCard && !selectedProvider) {
      navigate("/credit", { replace: true });
    }
  }, [isCreditCard, navigate, selectedProvider]);
  // Wingpay BillerId: backend operators list me billerId ho to wo, warna operatorId
  const billerId = selectedOperator?.billerId ?? selectedOperator?.operatorId;

  // ================= LOAD OPERATORS & CC BILLERS =================
  useEffect(() => {
    const load = async () => {
      try {
        const [opRes, ccRes] = await Promise.all([
          fetch_bill_operators(),
          fetch_active_cc_billers().catch(() => null),
        ]);

        let ops = opRes?.success ? (opRes.data?.operators || []) : [];
        let cats = opRes?.success ? (opRes.data?.categories || []) : [];

        // Dynamic Active Credit Card Billers from Admin
        if (ccRes?.success && Array.isArray(ccRes.data)) {
          const ccOps = ccRes.data.map((b) => ({
            operatorId: `CC_${b.billerId}`,
            billerId: String(b.billerId),
            name: b.operatorName,
            category: "Credit Card",
            displayname: "Card Last 4 Digits",
            viewbill: "1",
            active: b.status === "active",
          }));

          const existingBillerIds = new Set(
            ops
              .filter((o) => isCreditCardOperator(o))
              .map((o) => String(o.billerId ?? o.operatorId))
          );
          const newCCOps = ccOps.filter((o) => !existingBillerIds.has(String(o.billerId)));
          ops = [...ops, ...newCCOps];

          if (!cats.some((c) => /credit\s*card/i.test(c))) {
            cats = [...cats, "Credit Card"];
          }
        }

        setOperators(ops);
        setCategories(cats);
      } catch (err) {
        console.error("Failed to load operators:", err);
      }
    };
    load();
  }, []);

  // ================= SELECT OPERATOR =================
  useEffect(() => {
    const op = operators.find((o) => String(o.operatorId) === String(selectedOperatorId));
    setSelectedOperator(op || null);

    // Reset fields when operator changes
    setCanumber("");
    setAdFields(EMPTY_AD);
    setPaymentType("");
    setCardLast4("");
    setCustMobile("");
    setParam1("");
    setParam2("");
    setBillDetails(null);
    setShowForm(false);
    orderIdRef.current = null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperatorId]);

  // ================= VALIDATION =================
  const validateCreditCard = () => {
    if (!selectedOperator) {
      notify("Select operator", "error");
      return false;
    }
    if (!/^\d{4}$/.test(cardLast4)) {
      notify("Enter last 4 digits of credit card", "error");
      return false;
    }
    if (!/^[6-9]\d{9}$/.test(custMobile)) {
      notify("Enter valid 10 digit registered mobile number", "error");
      return false;
    }
    return true;
  };

  const validateInput = () => {
    if (!selectedOperator) {
      notify("Select operator", "error");
      return false;
    }

    if (!canumber.trim()) {
      notify(`Enter ${selectedOperator.displayname || "Consumer Number"}`, "error");
      return false;
    }

    // Consumer regex
    if (selectedOperator.regex) {
      try {
        const reg = new RegExp(selectedOperator.regex);
        if (!reg.test(canumber)) {
          notify("Invalid Consumer Number Format", "error");
          return false;
        }
      } catch {
        /* invalid regex from backend: ignore */
      }
    }

    for (const k of ["ad1", "ad2", "ad3", "ad4"]) {
      if (selectedOperator?.[`${k}_name`] && !adFields[k]) {
        notify(`Enter ${selectedOperator[`${k}_d_name`]}`, "error");
        return false;
      }
    }

    // Hero FinCorp payment type
    if (String(selectedOperatorId) === "157" && !paymentType) {
      notify("Select Payment Type", "error");
      return false;
    }

    return true;
  };

  // ================= LPG LOGIC =================
  const handleCanumberChange = (e) => {
    const value = e.target.value;
    setCanumber(value);

    // LPG Rule Paysprint
    if (selectedOperator?.category === "LPG") {
      if (value.length > 10) {
        setAdFields((p) => ({ ...p, ad1: "1" })); // LPG ID
      } else {
        setAdFields((p) => ({ ...p, ad1: "2" })); // Mobile
      }
    }
  };

  const buildAdPayload = () => {
    const adPayload = {};
    ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
      if (selectedOperator?.[`${k}_name`] && adFields[k]) {
        adPayload[k] = String(adFields[k]).trim(); // MUST be ad1/ad2 keys
      }
    });
    return adPayload;
  };

  // ================= FETCH BILL =================
  const handleProcessCreditCard = async () => {
    if (!selectedProvider) {
      notify("Select a credit card bill provider first", "error");
      navigate("/credit");
      return;
    }
    if (!ccProviderActive) {
      notify("This credit card bill provider is inactive", "error");
      return;
    }
    if (!validateCreditCard()) return;

    setLoading(true);
    try {
      const payload = {
        Last4DigitCardNumber: cardLast4,
        MobileNo: custMobile,
        BillerId: String(billerId),
        Param1: param1.trim(),
        Param2: param2.trim(),
        providerCode: selectedProvider,
        providerVersion: "v1",
      };

      const res = await fetch_cc_bill(payload);
      const d = res?.data;

      if (res?.success && d) {
        if (!d.referenceNumber) {
          notify("Bill reference not received from biller", "error");
        } else if (!(Number(d.amount) > 0)) {
          notify("No outstanding amount on this card", "info");
        } else {
          setBillDetails({
            name: d.name,
            amount: toMoney(d.amount),
            duedate: d.dueDate,
            billDate: d.billDate,
            billNumber: d.billNumber,
            referenceNumber: d.referenceNumber, // -> reference_id in payment
            additionalInfo: (d.additionalInfo || []).filter((i) => i?.infoName || i?.infoValue),
            cardLast4,
            mobile: custMobile,
          });
          orderIdRef.current = generateOrderId(cardLast4);
          setShowForm(true);
          notify("Bill fetched successfully", "success");
        }
      } else {
        notify(res?.message || "Bill fetch failed", "error");
      }
    } catch (err) {
      console.error("Credit card fetch error:", err);
      notify("Server Error", "error");
    }
    setLoading(false);
  };

  const handleProcess = async () => {
    if (isCreditCard) return handleProcessCreditCard();

    if (!validateInput()) return;

    setLoading(true);
    try {
      const payload = {
        operatorId: selectedOperatorId,
        canumber: String(canumber).trim(),
        mode: "online",
        ...buildAdPayload(),
        paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
      };

      const res = await fetch_billPay_info(payload);

      if (res?.success) {
        notify("Bill fetched successfully", "success");
        setBillDetails(res.data?.bill);
        setShowForm(true);
      } else {
        notify(res?.message || "Bill fetch failed", "error");
      }
    } catch (err) {
      console.error("Frontend Fetch Error:", err);
      notify("Server Error", "error");
    }

    setLoading(false);
  };

  // ================= PAY BILL =================
  const handleSubmitFromChild = async (data) => {
    if (!data?.amount) return notify("Enter amount", "error");

    setLoading(true);
    try {
      let location = savedLocation;
      if (!location) {
        location = await getLocation();
        dispatch(setLocation(location));
      }

      let res;

      if (isCreditCard) {
        if (!selectedProvider) {
          notify("Select a credit card bill provider first", "error");
          navigate("/credit");
          setLoading(false);
          return;
        }
        if (!orderIdRef.current) orderIdRef.current = generateOrderId(billDetails?.cardLast4 || "0000");

        const payload = {
          Last4DigitCardNumber: billDetails?.cardLast4,
          MobileNo: billDetails?.mobile,
          reference_id: billDetails?.referenceNumber, // fetch API ka referenceNumber
          amount: String(data.amount),
          BillerId: String(billerId),
          OrderId: orderIdRef.current,
          Param1: param1.trim(),
          Param2: param2.trim(),
          latitude: location.latitude,
          longitude: location.longitude,
          providerCode: selectedProvider,
          providerVersion: "v1",
        };
        res = await pay_cc_bill(payload);
      } else {
        const payload = {
          amount: data.amount,
          bill_fetch: billDetails?.bill_fetch,
          canumber: String(canumber),
          operator: selectedOperator.operatorId,
          category: selectedOperator.category,
          latitude: location.latitude,
          longitude: location.longitude,
          paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
          ...buildAdPayload(),
        };
        res = await submit_billPay_amount(payload);
      }

      if (res?.success) {
        const ref = res?.data?.operatorRefId;
        notify(ref ? `Payment Successful. Ref: ${ref}` : "Payment Successful", "success");
        ClearForm();
      } else {
        // OrderId jaan-bujhkar clear nahi kiya: retry par same OrderId jayega
        notify(res?.message || "Payment Failed", "error");
      }
    } catch (err) {
      console.error("Payment Error:", err);
      notify("Server Error", "error");
    }

    setLoading(false);
  };

  // ================= CLEAR =================
  const ClearForm = () => {
    setSelectedOperatorId("");
    setSelectedOperator(null);
    setCanumber("");
    setAdFields(EMPTY_AD);
    setPaymentType("");
    setCardLast4("");
    setCustMobile("");
    setParam1("");
    setParam2("");
    setBillDetails(null);
    setShowForm(false);
    orderIdRef.current = null;
  };

  // ================= UNIQUE OPERATORS (Active Only) =================
  const uniqueOperators = useMemo(() => {
    let list = operators.filter(
      (op, i, self) =>
        i ===
        self.findIndex(
          (o) =>
            (o.billerId && o.billerId === op.billerId) ||
            (o.operatorId && o.operatorId === op.operatorId) ||
            (o.name === op.name && o.category === op.category)
        )
    );

    // Inactive CC billers must never be displayed in the dropdown
    list = list.filter((op) => !isCreditCardOperator(op) || op.active !== false);

    if (selectedCategory) {
      list = list.filter((op) => op.category === selectedCategory);
    }
    return list;
  }, [operators, selectedCategory]);

  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-4">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "BBPS Bill Payment" },
            { label: "New Transaction", to: "/new-payment" },
            ...(selectedProvider ? [{ label: selectedProvider }] : []),
          ]}
        />
        {!ccProviderActive && selectedProvider && (
          <p className="mb-3 text-sm text-[var(--error-color)]">
            This provider is inactive.{" "}
            <button type="button" className="underline" onClick={() => navigate("/credit")}>
              Choose another provider
            </button>
          </p>
        )}

        <div className="ds-card mb-4 flex justify-between items-center gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={`${userInfo?.logo}`}
              alt=""
              className="h-10 w-10 rounded-ds object-cover shrink-0"
            />
            <div className="min-w-0">
              <p className="font-semibold text-[var(--text-dark)] truncate">{userInfo?.name}</p>
              <p className="text-[13px] text-[var(--text-muted)]">ID: {userInfo?.userName}</p>
            </div>
          </div>
          <p className="font-bold text-[var(--success-color)] whitespace-nowrap">
            ₹ {formatAmount(walletAmt?.addMoney?.balance)}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          <div className="ds-card w-full lg:max-w-[300px]">
            {/* <div className="mb-3">
              <label className="ds-label">Filter by Category</label>
              <select
                className="ds-input"
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setSelectedOperatorId("");
                  setSelectedOperator(null);
                }}
              >
                <option value="">All Categories ({categories.length})</option>
                {categories.map((c, i) => (
                  <option key={i} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div> */}

            <label className="ds-label">Select Operator *</label>
            <Autocomplete
              options={uniqueOperators}
              getOptionLabel={(op) => op?.name || ""}
              value={
                uniqueOperators.find((o) => String(o.operatorId) === String(selectedOperatorId)) ||
                null
              }
              onChange={(e, v) => {
                setSelectedOperatorId(v?.operatorId || "");
                setSelectedOperator(v || null);
              }}
              filterOptions={(options, { inputValue }) => {
                const val = inputValue.toLowerCase();
                return options.filter(
                  (o) =>
                    o.name?.toLowerCase().includes(val) || o.category?.toLowerCase().includes(val)
                );
              }}
              renderOption={(props, option) => (
                <li
                  {...props}
                  key={option.operatorId}
                  className="flex justify-between items-start gap-2 p-1 overflow-x-hidden cursor-pointer"
                >
                  <span className="text-sm font-medium cursor-pointer">{option.name}</span>
                  <span className="text-xs text-[var(--warning-color)] cursor-pointer">{option.category}</span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search Operator..."
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: "0.9rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  }}
                />
              )}
              fullWidth
            />

            {/* ============ CREDIT CARD FIELDS ============ */}
            {isCreditCard ? (
              <>
                <label className="ds-label mt-3">Last 4 Digits of Card *</label>
                <TextField
                  fullWidth
                  size="small"
                  value={cardLast4}
                  placeholder="e.g. 6733"
                  inputProps={{ inputMode: "numeric", maxLength: 4 }}
                  onChange={(e) => setCardLast4(e.target.value.replace(/\D/g, "").slice(0, 4))}
                />

                <label className="ds-label mt-2">Registered Mobile Number *</label>
                <TextField
                  fullWidth
                  size="small"
                  value={custMobile}
                  placeholder="10 digit mobile"
                  inputProps={{ inputMode: "numeric", maxLength: 10 }}
                  onChange={(e) => setCustMobile(e.target.value.replace(/\D/g, "").slice(0, 10))}
                />

                {/* Param1/Param2 optional hain, sirf tab dikhao jab biller ko chahiye ho */}
                {selectedOperator?.param1_name && (
                  <>
                    <label className="ds-label mt-2">{selectedOperator.param1_name}</label>
                    <TextField
                      fullWidth
                      size="small"
                      value={param1}
                      onChange={(e) => setParam1(e.target.value)}
                    />
                  </>
                )}
                {selectedOperator?.param2_name && (
                  <>
                    <label className="ds-label mt-2">{selectedOperator.param2_name}</label>
                    <TextField
                      fullWidth
                      size="small"
                      value={param2}
                      onChange={(e) => setParam2(e.target.value)}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <label className="ds-label mt-3">
                  {selectedOperator?.displayname || "Consumer Number"} *
                </label>
                <TextField
                  fullWidth
                  size="small"
                  value={canumber}
                  onChange={handleCanumberChange}
                />

                {String(selectedOperatorId) === "157" && (
                  <>
                    <label className="ds-label mt-2">Payment Type</label>
                    <Autocomplete
                      options={[
                        "Installment Amount Due",
                        "Full Overdue",
                        "Advance EMI",
                        "Foreclosure",
                      ]}
                      value={paymentType || null}
                      onChange={(e, v) => setPaymentType(v || "")}
                      renderInput={(p) => <TextField {...p} size="small" />}
                    />
                  </>
                )}

                {["ad1", "ad2", "ad3", "ad4"].map((k) =>
                  selectedOperator?.[`${k}_name`] ? (
                    <div key={k}>
                      <label className="ds-label mt-2">{selectedOperator[`${k}_d_name`]}</label>
                      <TextField
                        fullWidth
                        size="small"
                        value={adFields[k]}
                        onChange={(e) => setAdFields({ ...adFields, [k]: e.target.value })}
                      />
                    </div>
                  ) : null
                )}
              </>
            )}

            <div className="ds-form-actions">
              <button
                type="button"
                onClick={handleProcess}
                disabled={loading}
                className="ds-btn ds-btn-primary"
              >
                {loading ? "Processing..." : isCreditCard ? "Fetch Bill" : "Process"}
              </button>
              <button type="button" onClick={ClearForm} className="ds-btn ds-btn-secondary">
                Clear
              </button>
            </div>
          </div>

          {!showForm && (
            <div className="ds-card flex-1">
              <h3 className="text-[15px] font-semibold mb-3 text-[var(--text-dark)]">
                Supported Categories
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 text-[13px] gap-2 text-[var(--text-muted)]">
                {categories.map((c, i) => (
                  <p key={i} className="flex items-center gap-1.5">
                    <span className="text-[var(--success-color)]">✓</span> {c}
                  </p>
                ))}
              </div>
            </div>
          )}

          {showForm && (
            <ServicesForm
              bill={billDetails}
              close={ClearForm}
              onSubmit={handleSubmitFromChild}
              loading={loading}
            />
          )}
        </div>
      </div>
    </Main>
  );
};

export default NewPayment;    





// import React from "react";
// import Main from "../pages/Main";
// import { AppBreadcrumbs } from "../components/listing";

// const NewPayment = () => {
//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "BBPS Bill Payment" },
//             { label: "New Transaction" },
//           ]}
//         />

//         <div className="ds-card min-h-[420px] flex flex-col items-center justify-center text-center px-6 py-12">
//           <div className="w-24 h-24 rounded-full bg-blue-50 flex items-center justify-center mb-6">
//             <svg
//               className="w-12 h-12 text-blue-700 animate-pulse"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               strokeWidth={1.6}
//             >
//               <circle cx="12" cy="12" r="9" />
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M12 7v5l3 2"
//               />
//             </svg>
//           </div>

//           <h2 className="text-2xl md:text-3xl font-bold text-[var(--text-dark)] mb-4">
//             Service Under Processing
//           </h2>

//           <p className="text-sm md:text-base text-[var(--text-muted)] max-w-lg leading-7">
//             This service is currently under processing and will be available
//             very soon. Thank you for your patience and support.
//           </p>

//           <div className="mt-7 px-5 py-2.5 rounded-full bg-blue-50 text-blue-700 text-sm font-semibold">
//             Under Processing
//           </div>
//         </div>
//       </div>
//     </Main>
//   );
// };

// export default NewPayment;